import { ScientificAnalysis } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'

export interface ScientificAnalysisSaveModalState {
    scientificAnalysis:ScientificAnalysis | null
    existingId: number | null
    name: string
    clone: boolean
}
export const initialScientificAnalysisSaveModalState =
    (): ScientificAnalysisSaveModalState => ({
        scientificAnalysis: null,
        existingId: null,
        name: '',
        clone: true
    })
